import { ComboField } from '@components/Fields/ComboField';
import { DateField } from '@components/Fields/DateField';
import { FloatField } from '@components/Fields/FloatField';
import { StringField } from '@components/Fields/StringField';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { IForm } from '@hooks/useForm';
import { IComboEmpresa } from '@model/Empresa';
import { IDespesaRegistrarRecibo } from '@services/DespesaService';
import React from 'react';

export type DespesaRegistrarReciboFormProps = {
    form: IForm<IDespesaRegistrarRecibo>
    empresaCombo: IComboEmpresa
}

export function DespesaRegistrarReciboForm ({ form, empresaCombo }: DespesaRegistrarReciboFormProps) {
    const { fields } = form;

    return (
        <HorizontalGrid spacing={1}>
            <GridItem xs={2}>
                <ComboField 
                    field={fields.empresaId}
                    label="Empresa"
                    required
                >
                    {
                        empresaCombo.createOptions()
                    }
                </ComboField>
            </GridItem>

            <GridItem xs={2}>
                <DateField 
                    field={fields.dataReferencia}
                    label="Data"
                    required
                />
            </GridItem>

            <GridItem xs={6}>
                <StringField 
                    field={fields.descricao}
                    label="Identificador"
                    helperText="O que aparecerá na descrição da consulta"
                    required
                />
            </GridItem>

            <GridItem xs={2}>
                <FloatField
                    field={fields.valor}
                    label="Valor"
                    required
                />
            </GridItem>

            <GridItem xs={12}>
                <StringField
                    field={fields.referencia}
                    label="Referente a"
                    multiline
                    required
                />
            </GridItem>
        </HorizontalGrid>
    )
}